export default function initProjectsFilter(): void {
  Alpine.data('projectsFilter', () => ({
    selectedCategories: [] as string[],
    filterTimeout: null as number | null,

    init() {
      // Cache projects for better performance
      const projects: NodeListOf<HTMLElement> = this.$root.querySelectorAll('.project');

      this.$watch('selectedCategories', () => {
        // Clear any pending filter operation
        if (this.filterTimeout) {
          clearTimeout(this.filterTimeout);
        }

        // Debounce the filtering operation to improve performance
        this.filterTimeout = setTimeout(() => {
          this.updateProjectsVisibility(projects);
        }, 16); // One frame delay for smooth UX
      });
    },

    updateProjectsVisibility(projects: NodeListOf<HTMLElement>) {
      // Use requestAnimationFrame for smooth DOM updates
      requestAnimationFrame(() => {
        projects.forEach((project) => {
          const categories = project.dataset.category?.split(',');
          if (categories) {
            const hasSelectedCategory = this.selectedCategories
              .some((cat) => categories.includes(cat));
            const shouldShow = this.selectedCategories.length === 0 || hasSelectedCategory;

            // Batch DOM updates to reduce layout thrashing
            if (shouldShow && project.classList.contains('hidden')) {
              // Show project with smooth transition
              project.classList.remove('hidden');
              // Force reflow to ensure hidden is removed before animation
              project.classList.remove('opacity-0', 'scale-95', 'pointer-events-none');
              project.classList.add('opacity-100', 'scale-100', 'pointer-events-auto');
            } else if (!shouldShow && !project.classList.contains('hidden')) {
              // Hide project with smooth transition
              project.classList.remove('opacity-100', 'scale-100', 'pointer-events-auto');
              project.classList.add('opacity-0', 'scale-95', 'pointer-events-none');
              // Hide after animation completes
              setTimeout(() => {
                if (this.selectedCategories.length === 0
                    || !this.selectedCategories.some((cat) => categories.includes(cat))) {
                  project.classList.add('hidden');
                }
              }, 200); // Match CSS transition duration
            }
          }
        });
      });
    },

    filter() {
      const checkbox = this.$el as HTMLInputElement;
      const category = checkbox.value;

      // Update checkbox state immediately for responsive feel
      if (checkbox.checked) {
        if (!this.selectedCategories.includes(category)) {
          this.selectedCategories.push(category);
        }
      } else {
        this.selectedCategories = this.selectedCategories.filter((cat) => cat !== category);
      }
    },
  }));
}
